<template>
	<div class="page-header page-header-light shadow">

		<!-- breadcrumb -->
		<div class="page-header-content d-lg-flex">
			<div class="d-flex">
				<h4 class="page-title mb-0">
					<router-link href="#" class="mb-xs-1 text-dark cursor-pointer" :to="'Dashboard'"><i
							class="icon-arrow-left52 me-1"></i></router-link>
					<a href="#" class="hidden-xs text-dark fw-semibold cursor-pointer"
						v-on:click="getNoteSpese()">Contabilità</a>
					<span class="hidden-xs ms-1">\</span>
					<span class="text-muted ms-1">Le mie note spese</span>
				</h4>
				<a href="#page_header"
					class="hidden-lg btn btn-light align-self-center collapsed border-transparent rounded-pill p-0 ms-auto"
					data-bs-toggle="collapse">
					<i class="ph-caret-down collapsible-indicator ph-sm m-1"></i>
				</a>
			</div>
			<div class="collapse d-lg-block my-lg-auto ms-lg-auto text-center" id="page_header">
				<div class="d-sm-flex align-items-center mb-3 mb-lg-0 ms-lg-3">

					<a href="#" class="d-inline-flex align-items-center text-body lh-1 py-sm-2 position-10"
						style="text-align: left;" v-on:click="showModalNuovaElaborazione = true" v-if="isAdminView">
						<i class="ph-plus fw-bold me-2 btn btn-outline-success w-32px h-32px rounded-pill"></i>
						<div class="me-auto me-lg-1 ms-1">
							<div class="fs-sm text-muted mb-0">
								<Translate :path="'dizionario.base.BTN_NUOVA'"></Translate> elaborazione
							</div>
							<div class="text-success fw-semibold">
								<Translate :path="'dizionario.base.BTN_ADD'"></Translate>
							</div>
						</div>
					</a>

					<div class="vr flex-shrink-0 my-2 mx-3"></div>

					<div class="d-inline-flex float-end mt-sm-0">
						<a v-show="this.modulo != 2" href="#"
							class="btn btn-outline-light btn-icon w-32px h-32px squared-pill"
							v-on:click="$root.confTravelTipologiche(62)" title="Configurazione Note Spese"
							data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="ph-lightning"></i>
						</a>
						<a href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill ms-2"
							v-on:click="$root.confTravelLingue(62)" title="Definizioni Lingua"
							data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="ph-flag"></i>
						</a>
						<a href="#" class="btn btn-outline-pink btn-icon w-32px h-32px squared-pill ms-2"
							v-on:click="$root.help(62)" title="Help OnLIne" data-bs-toggle="tooltip"
							data-bs-placement="left">
							<i class="icon-question7 pink"></i>
						</a>
					</div>
				</div>
			</div>
		</div>
		<!-- /breadcrumb -->

		<!-- Profile navigation -->
		<div class="navbar navbar-expand-lg border-top py-1">
			<div class="container-fluid">
				<ul class="nav navbar-nav flex-row flex-fill" role="tablist">
					<li class="nav-item me-1" role="presentation">
						<a href="#notespese-tab" class="navbar-nav-link navbar-nav-link-icon navbar-sm active rounded"
							data-bs-toggle="tab" aria-selected="true" role="tab">
							<div class="d-flex align-items-center mx-lg-1">
								<i class="ph-list"></i>
								<span class="hidden-lg ms-1">Note Spese</span>
								<span class="hidden-xs ms-1">Le mie note spese</span>
							</div>
						</a>
					</li>
					<li class="nav-item me-1" role="presentation" v-if="isAdminView">
						<a href="#elaborazioni-tab" class="navbar-nav-link navbar-nav-link-icon navbar-sm rounded"
							data-bs-toggle="tab" aria-selected="false" role="tab" @click="onTabElaborazioni">
							<div class="d-flex align-items-center mx-lg-1">
								<i class="ph-stack"></i>
								<span class="hidden-lg ms-1">Elaborazioni</span>
								<span class="hidden-xs ms-1">Elaborazioni</span>
							</div>
						</a>
					</li>
					<li class="nav-item me-1" role="presentation" v-if="false">
						<a href="#statistiche-tab" class="navbar-nav-link navbar-nav-link-icon navbar-sm rounded"
							data-bs-toggle="tab" aria-selected="false" role="tab" @click="onTabStatistiche">
							<div class="d-flex align-items-center mx-lg-1">
								<i class="ph-chart-bar"></i>
								<span class="hidden-lg ms-1">Statistiche</span>
								<span class="hidden-xs ms-1">Statistiche</span>
							</div>
						</a>
					</li>
					<li class="nav-item d-lg-none ms-auto">
						<a href="#profile_nav" class="navbar-nav-link navbar-nav-link-icon rounded-pill rounded-pill-small collapsed" data-bs-toggle="collapse" aria-expanded="false">
							<i class="ph-caret-down collapsible-indicator"></i>
						</a>
					</li>
				</ul>
				<div class="navbar-collapse collapse" id="profile_nav">
					<ul class="navbar-nav ms-lg-auto mt-2 mt-lg-0 select-small">
						<li class="nav-item dropdown ms-lg-1">
							<div class="btn-group">
								<a href="#" class="btn btn-flat-danger border-transparent btn-sm"
									@click.prevent="apriUploadPdf()" title="Carica PDF scontrini"
									data-bs-toggle="tooltip" data-bs-placement="left">
									<i class="ph-upload me-1"></i>
									<span style="font-size:0.8rem;">Carica PDF scontrini</span>
								</a>
								<a href="#" class="btn btn-flat-indigo border-transparent btn-sm btn-icon"
									@click.prevent="getNoteSpese()" title="Aggiorna"
									data-bs-toggle="tooltip" data-bs-placement="left">
									<i class="ph-arrows-clockwise"></i>
								</a>
								<a href="#" class="btn btn-flat-indigo border-transparent btn-sm dropdown-toggle"
									data-bs-toggle="dropdown" aria-expanded="false">
									<i class="ph-gear me-1"></i>
									<span style="font-size:0.8rem;">Azioni Multiple</span>
								</a>
								<div class="dropdown-menu dropdown-menu-end" ref="azioniMultipleMenu">
									<div class="dropdown-submenu dropdown-submenu-start">
									<a href="#" class="dropdown-item">
										<i class="far fa-ballot-check fa-fw me-2"></i><span class="text-muted me-1">|</span>Stato
									</a>
									<div class="dropdown-menu">
										<a href="#" class="dropdown-item" @click.prevent="attivaSelezionati()">
											<i class="far fa-check-square fa-fw me-2"></i>Attiva selezionati
										</a>
										<a href="#" class="dropdown-item" @click.prevent="disattivaSelezionati()">
											<i class="far fa-square fa-fw me-2"></i>Disattiva selezionati
										</a>
									</div>
								</div>
									<div class="dropdown-submenu dropdown-submenu-start">
									<a href="#" class="dropdown-item">
										<i class="far fa-file-alt fa-fw me-2"></i><span class="text-muted me-1">|</span>Tipo giustificativo
									</a>
									<div class="dropdown-menu">
										<a href="#" class="dropdown-item" @click.prevent="segnaScontriniSelezionati()">
											<i class="fas fa-receipt fa-fw me-2"></i>Segna come Scontrino
										</a>
										<a href="#" class="dropdown-item" @click.prevent="segnaFattureSelezionati()">
											<i class="fas fa-file-invoice fa-fw me-2"></i>Segna come Fattura
										</a>
									</div>
								</div>
								<div class="dropdown-divider"></div>
								<a href="#" class="dropdown-item" @click.prevent="associaProgettoSelezionati()">
									<i class="ph-link-break fa-fw me-2"></i><span class="text-muted me-1">|</span>Associa a progetto
								</a>
									<div class="dropdown-submenu dropdown-submenu-start">
										<a href="#" class="dropdown-item">
											<i class="far fa-file-export fa-fw me-2"></i>
											<span class="text-muted me-1">|</span>Esporta dati
										</a>
										<div class="dropdown-menu">
											<a href="#" class="dropdown-item" @click.prevent="apriEsportazione('pagina')">
												<i class="far fa-file-export fa-fw me-2"></i>Pagina corrente
											</a>
											<a href="#" class="dropdown-item" @click.prevent="apriEsportazione('selezionati')">
												<i class="far fa-file-export fa-fw me-2"></i>Note spese selezionate
											</a>
											<a href="#" class="dropdown-item" @click.prevent="apriEsportazione('tutti')">
												<i class="far fa-file-export fa-fw me-2"></i>Tutte le note spese
											</a>
										</div>
									</div>
								</div>
							</div>
						</li>
						<li class="nav-item">

						</li>
					</ul>
				</div>
			</div>
		</div>
		<!-- /profile navigation -->

	</div>

	<div class="content content-1 table-cms-wrapper">
		<div class="tab-content flex-1 order-2 order-lg-1">
			<div class="tab-pane fade active show" id="notespese-tab">
				<div class="card shadow mb-xs-3 mb-lg-0">

					<div class="card-header d-lg-none p-1">
						<div class="d-grid gap-2">
							<a href="#collapse-notespese" class="btn btn-flat-info btn-sm collapsed"
								data-bs-toggle="collapse" role="button" aria-expanded="false">
								MOSTRA FILTRI
							</a>
						</div>
					</div>

					<div class="collapse" :class="{ show: !$root.isMobile }" id="collapse-notespese">
						<div class="card-body pb-0">
							<div class="alert alert-2 alert-secondary border-0">
								<form autocomplete="off" action="#" id="notespese-f">
									<div class="row">
										<div class="col-12 col-md-2 col-lg-1 mbx-1">
											<input autocomplete="off" class="form-control form-control-sm" type="text"
												placeholder="Descrizione" v-model="search.DESCRIZIONE.VALUE" />
										</div>
										<div class="col-6 col-md-1 col-lg-1 mbx-1">
											<Datepicker
												autocomplete="off"
												class="bg-light"
												placeholder="Data da"
												v-model="dataFrom"
												@update:model-value="handleDataFromChange"
												:formats="{ input: 'dd/MM/yyyy' }"
												model-type="yyyy-MM-dd"
												auto-apply
												style="width:100%"
											/>
										</div>
										<div class="col-6 col-md-1 col-lg-1 mbx-1">
											<Datepicker
												autocomplete="off"
												class="bg-light"
												placeholder="Data a"
												v-model="dataTo"
												@update:model-value="handleDataToChange"
												:formats="{ input: 'dd/MM/yyyy' }"
												model-type="yyyy-MM-dd"
												auto-apply
												style="width:100%"
											/>
										</div>
										<div class="col-12 col-md-2 col-lg-2 mbx-1" v-if="isAdminView">
											<Select2Locale
												v-model="search.FK_ID_UTENTE.VALUE"
												:placeholder="'Utente'"
												:options="optionsUtentiFiltro" />
										</div>
										<div class="col-12 col-md-2 col-lg-2 mbx-1">
											<Select2Locale
												v-model="search.FK_ID_PROGETTO.VALUE"
												:placeholder="'Progetto'"
												:options="optionsProgettiFiltro" />
										</div>
										<div class="col-6 col-md-1 col-lg-1 mbx-1">
											<select class="form-select form-select-sm" v-model="search.FK_ID_CATEGORIA.VALUE">
												<option value="">Categoria</option>
												<option v-for="c in arrayCategorieSpese" :key="c.ID_OPZIONE_TIPOLOGICA" :value="c.ICONA">
													{{ c.DESCRIZIONE }}
												</option>
											</select>
										</div>

										<!-- Filtri secondari: visibili su lg+, nascosti su md/sm/xs -->
										<div class="col-6 col-md-1 col-lg-1 mbx-1 d-none d-lg-block">
											<select class="form-select form-select-sm" v-model="search.ASSOCIATO.VALUE">
												<option value="">Tutti</option>
												<option value="1">Associate</option>
												<option value="0">Non associate</option>
											</select>
										</div>
										<div class="col-6 col-md-1 col-lg-1 mbx-1 d-none d-lg-block">
											<select class="form-select form-select-sm" v-model="search.FLG_FATTURA.VALUE">
												<option value="">Tutti</option>
												<option value="0">Scontrini</option>
												<option value="1">Fatture</option>
											</select>
										</div>
										<div class="col-6 col-md-1 col-lg-1 mbx-1 d-none d-lg-block">
											<select class="form-select form-select-sm" v-model="search.TIPO_MOVIMENTO.VALUE">
												<option value="">Tutti</option>
												<option value="0">Addebiti</option>
												<option value="1">Accrediti</option>
											</select>
										</div>
										<div class="col-6 col-md-1 col-lg-1 mbx-1 d-none d-lg-block" v-if="$root.isGod">
											<select class="form-select form-select-sm" v-model="search.FLG_ELIMINATO.VALUE">
												<option value="0">Non eliminate</option>
												<option value="">Tutte</option>
												<option value="1">Eliminate</option>
											</select>
										</div>
										<!-- Bottone + FILTRI: visibile su md/sm/xs, nascosto su lg+ -->
										<div class="col-6 col-md-1 col-lg-1 mbx-1 d-lg-none">
											<a href="#collapse-ns-filtri"
												class="btn btn-flat-info btn-sm w-100 collapsed"
												data-bs-toggle="collapse"
												v-on:click="filters.resizeGrid('collapse-ns-filtri','tableFixHead','box-card')"
												role="button" aria-expanded="false">
												+ FILTRI
											</a>
										</div>
									</div>

									<!-- Collapse: usato solo su md/sm/xs, stessi v-model dei secondari -->
									<div class="collapse" id="collapse-ns-filtri">
										<div class="row mt-1">
											<div class="col-6 col-md-2 col-lg-2 mbx-1">
												<select class="form-select form-select-sm" v-model="search.ASSOCIATO.VALUE">
													<option value="">Tutti</option>
													<option value="1">Associate</option>
													<option value="0">Non associate</option>
												</select>
											</div>
											<div class="col-6 col-md-2 col-lg-2 mbx-1">
												<select class="form-select form-select-sm" v-model="search.FLG_FATTURA.VALUE">
													<option value="">Tutti</option>
													<option value="0">Scontrini</option>
													<option value="1">Fatture</option>
												</select>
											</div>
											<div class="col-6 col-md-2 col-lg-2 mbx-1">
												<select class="form-select form-select-sm" v-model="search.TIPO_MOVIMENTO.VALUE">
													<option value="">Tutti</option>
													<option value="0">Addebiti</option>
													<option value="1">Accrediti</option>
												</select>
											</div>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>

					<div class="card-body box-card mt-0 mb-0" id="box-card">
						<div class="div_table_resp tableFixHead" id="tableFixHead">
							<div v-if="paginatedList.arr.length == 0" class="table-head-sm text-center text-muted py-3">Nessuna nota spesa trovata</div>

							<table v-else class="table table-bordered table-hover table-striped" style="table-layout: fixed; width: 100%;">
								<thead v-if="!$root.isMobile" class="sticky-top thead-bordered bg-secondary">
									<tr class="bg-secondary text-white">
										<th class="table-head-sm text-center" style="width:2%">
											<input id="chkAllNoteSpese" type="checkbox" v-on:click="filters.selectAll('chkAllNoteSpese', paginatedList.arr)" />
										</th>
										<th v-if="isAdminView" class="table-head-sm" style="width:10%">Utente<ISort class="float-end" v-model="ordinamento" :campo="'NOME_UTENTE'"></ISort></th>
										<th class="table-head-sm" style="width:9%">Data<ISort class="float-end" v-model="ordinamento" :campo="'DATA'"></ISort></th>
										<th class="table-head-sm" :style="isAdminView ? 'width:18%' : 'width:28%'">Descrizione<ISort class="float-end" v-model="ordinamento" :campo="'DESCRIZIONE'"></ISort></th>
										<th class="table-head-sm" style="width:12%">Categoria</th>
										<th class="table-head-sm text-end" style="width:8%">Importo<ISort class="float-end" v-model="ordinamento" :campo="'IMPORTO'"></ISort></th>
										<th class="table-head-sm" style="width:12%">Progetto<ISort class="float-end" v-model="ordinamento" :campo="'TITOLO_PROGETTO'"></ISort></th>
										<th class="table-head-sm text-center" style="width:5%">Tipo</th>
										<th class="table-head-sm text-center" style="width:5%">Azioni</th>
									</tr>
								</thead>
								<tbody>
									<NotaSpesaNode
										v-for="nota in paginatedList.arr"
										:key="nota.ID_NOTA_SPESA"
										:nota-spesa="nota"
										:read-only="false"
										:show-associa-progetto="true"
										:show-utente="isAdminView"
										:show-progetto="true"
										:show-checkbox="true"
										:arrayCategorieSpese="arrayCategorieSpese"
										@apri-azioni="apriAzioni"
										@update:selezionato="(val) => nota.SELEZIONATO = val"
									/>
								</tbody>
							</table>
						</div>

						<!-- Pagination and Footer -->
						<div class="row page-bottom">
							<div class="col-12 col-md-5 d-none d-sm-block">
								<div style="position: relative; top: 10px;">
									<span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2">
										<span>NOTE SPESE</span>: {{ paginatedList.count }}
									</span>
									<span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2 ms-2">
										TOTALE: € {{ filters.formattaImporto(
											isAdminView
												? utils.array.sumByFieldSigned(arrayNoteSpese, 'IMPORTO', 'TIPO_MOVIMENTO')
												: utils.array.sumByField(arrayNoteSpese, 'IMPORTO')
										) }}
									</span>
								</div>
							</div>
							<div class="col-9 col-md-6" :tabindex="27">
								<div class="float-end">
									<Pagine v-model="search.PAGINATION.PAGE_NUMBER"
										:numrighe="paginatedList.count"
										:numpagine="search.PAGINATION.LENGTH" :modalita="$root.isMobile ? 2 : 1" />
								</div>
							</div>
							<div class="col-3 col-md-1" :tabindex="28">
								<select v-model.number="search.PAGINATION.PAGE_SIZE"
									class="form-select form-select-sm wmin-100 mt-2 float-end"
									style="position: relative; top: 0px;" data-placeholder="Limite" :tabindex="20">
									<option :value="5">5</option>
									<option :value="10">10</option>
									<option :value="25">25</option>
									<option :value="50">50</option>
									<option :value="75">75</option>
									<option :value="100">100</option>
								</select>
							</div>
						</div>
					</div>

				</div>
			</div>
			<div class="tab-pane fade" id="elaborazioni-tab">
				<div class="card shadow mb-xs-3 mb-lg-0">
					<div class="card-header d-lg-none p-1">
						<div class="d-grid gap-2">
							<a href="#collapse-elaborazioni" class="btn btn-flat-info btn-sm collapsed"
								data-bs-toggle="collapse" role="button" aria-expanded="false">
								MOSTRA FILTRI
							</a>
						</div>
					</div>

					<div class="collapse" :class="{ show: !$root.isMobile }" id="collapse-elaborazioni">
						<div class="card-body pb-0">
							<div class="alert alert-2 alert-secondary border-0">
								<form autocomplete="off" action="#" id="elaborazioni-f">
									<div class="row g-2 align-items-end">
										<div class="col-12 col-md-3" v-if="isAdminView">
											<select class="form-select form-select-sm" v-model="searchElab.NOME_UTENTE">
												<option value="">Utente</option>
												<option v-for="nome in utentiElab" :key="nome" :value="nome">{{ nome }}</option>
											</select>
										</div>
										<div class="col-6 col-md-2">
											<Datepicker
												autocomplete="off"
												class="bg-light w-100"
												placeholder="Data da"
												v-model="elabDataFrom"
												@update:model-value="handleElabDataFromChange"
												:formats="{ input: 'dd/MM/yyyy' }"
												model-type="yyyy-MM-dd"
												auto-apply
											/>
										</div>
										<div class="col-6 col-md-2">
											<Datepicker
												autocomplete="off"
												class="bg-light w-100"
												placeholder="Data a"
												v-model="elabDataTo"
												@update:model-value="handleElabDataToChange"
												:formats="{ input: 'dd/MM/yyyy' }"
												model-type="yyyy-MM-dd"
												auto-apply
											/>
										</div>
										<div class="col-6 col-md-2">
											<select class="form-select form-select-sm" v-model="searchElab.QUADRATURA">
												<option value="">Quadratura</option>
												<option value="1">OK</option>
												<option value="0">Non OK</option>
											</select>
										</div>
										<div class="col-6 col-md-1">
											<button class="btn btn-flat-secondary btn-sm text-nowrap w-100" type="button" @click="resetElabFilters">
												<i class="ph-x me-1"></i>Resetta
											</button>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>

					<div class="card-body box-card mt-0 mb-0">
						<div class="div_table_resp">
							<table class="table table-bordered table-hover table-striped" :style="!$root.isMobile ? 'min-width:520px;' : ''">
								<thead v-if="!$root.isMobile" class="thead-bordered bg-secondary">
									<tr class="bg-secondary text-white">
										<th class="table-head-sm">Utente</th>
										<th class="table-head-sm text-nowrap">Data</th>
										<th class="table-head-sm text-center text-nowrap">Tot. movimenti</th>
										<th class="table-head-sm text-center text-nowrap">Tot. scontrini</th>
										<th class="table-head-sm text-center text-nowrap">Tot. fatture</th>
										<th class="table-head-sm text-center text-nowrap">Quadratura</th>
									</tr>
								</thead>
								<tbody>
									<tr v-if="filteredElaborazioni.length == 0">
										<td colspan="6" class="table-head-sm text-center text-muted py-3">Nessuna elaborazione trovata</td>
									</tr>
									<tr v-for="elab in filteredElaborazioni" :key="elab.ID_ELABORAZIONE">
										<template v-if="!$root.isMobile">
											<td class="table-head-sm">{{ elab.NOME_UTENTE }}</td>
											<td class="table-head-sm text-nowrap">{{ filters.formatDate(elab.DATA) }}</td>
											<td class="table-head-sm text-center text-nowrap">{{ elab.TOT_MOVIMENTI }}</td>
											<td class="table-head-sm text-center text-nowrap">{{ elab.TOT_SCONTRINI }}</td>
											<td class="table-head-sm text-center text-nowrap">{{ elab.TOT_FATTURE }}</td>
											<td class="table-head-sm text-center text-nowrap">
												<span class="badge" :class="quadraturaOk(elab) ? 'bg-success' : 'bg-danger'">
													{{ quadraturaOk(elab) ? 'OK' : (parseInt(elab.TOT_SCONTRINI) + parseInt(elab.TOT_FATTURE)) + '/' + elab.TOT_MOVIMENTI }}
												</span>
											</td>
										</template>
										<td v-else colspan="6" class="p-0">
											<div class="elab-mobile-row d-flex align-items-center justify-content-between p-2" @click="toggleElab(elab.ID_ELABORAZIONE)">
												<div class="d-flex align-items-center flex-grow-1 min-w-0">
													<i :class="isElabExpanded(elab.ID_ELABORAZIONE) ? 'ph-caret-down' : 'ph-caret-right'" class="me-2 flex-shrink-0 text-muted"></i>
													<div class="min-w-0">
														<div class="fw-semibold text-truncate">{{ elab.NOME_UTENTE }}</div>
														<div class="text-muted" style="font-size:0.75rem;">{{ filters.formatDate(elab.DATA) }}</div>
													</div>
												</div>
												<span class="badge flex-shrink-0" :class="quadraturaOk(elab) ? 'bg-success' : 'bg-danger'">
													{{ quadraturaOk(elab) ? 'OK' : (parseInt(elab.TOT_SCONTRINI) + parseInt(elab.TOT_FATTURE)) + '/' + elab.TOT_MOVIMENTI }}
												</span>
											</div>
											<div v-if="isElabExpanded(elab.ID_ELABORAZIONE)" class="elab-mobile-details p-2 pt-0" @click.stop>
												<div class="row g-2">
													<div class="col-4">
														<small class="text-muted d-block">Tot. movimenti</small>{{ elab.TOT_MOVIMENTI }}
													</div>
													<div class="col-4">
														<small class="text-muted d-block">Tot. scontrini</small>{{ elab.TOT_SCONTRINI }}
													</div>
													<div class="col-4">
														<small class="text-muted d-block">Tot. fatture</small>{{ elab.TOT_FATTURE }}
													</div>
												</div>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
			<div class="tab-pane fade" id="statistiche-tab">
				<div class="card shadow mb-xs-3 mb-lg-0">

					<div class="card-header d-lg-none p-1">
						<div class="d-grid gap-2">
							<a href="#collapse-statistiche" class="btn btn-flat-info btn-sm collapsed"
								data-bs-toggle="collapse" role="button" aria-expanded="false">
								MOSTRA FILTRI
							</a>
						</div>
					</div>

					<div class="collapse" :class="{ show: !$root.isMobile }" id="collapse-statistiche">
						<div class="card-body pb-0">

								<!-- Filtri statistiche -->
								<div class="alert alert-2 alert-secondary border-0 mb-4">
									<form autocomplete="off" action="#" id="statistiche-f">
										<div class="row g-2 align-items-end">
											<div class="col-6 col-md-2">
												<Datepicker
													autocomplete="off"
													class="bg-light w-100"
													placeholder="Data da"
													v-model="statsDataFrom"
													@update:model-value="handleStatsDataFromChange"
													:formats="{ input: 'dd/MM/yyyy' }"
													model-type="yyyy-MM-dd"
													auto-apply
												/>
											</div>
											<div class="col-6 col-md-2">
												<Datepicker
													autocomplete="off"
													class="bg-light w-100"
													placeholder="Data a"
													v-model="statsDataTo"
													@update:model-value="handleStatsDataToChange"
													:formats="{ input: 'dd/MM/yyyy' }"
													model-type="yyyy-MM-dd"
													auto-apply
												/>
											</div>
											<div class="col-12 col-md-2" v-if="isAdminView">
												<select class="form-select form-select-sm" v-model="searchStats.NOME_UTENTE">
													<option value="">Utente</option>
													<option v-for="nome in utentiStats" :key="nome" :value="nome">{{ nome }}</option>
												</select>
											</div>
											<div class="col-12 col-md-3">
												<select class="form-select form-select-sm" v-model="searchStats.FK_ID_PROGETTO">
													<option value="">Progetto</option>
													<option v-for="p in progettiStats" :key="p.id" :value="p.id">{{ p.title }}</option>
												</select>
											</div>
											<div class="col-6 col-md-2">
												<select class="form-select form-select-sm" v-model="searchStats.TIPO_MOVIMENTO">
													<option value="">Tipo</option>
													<option value="0">Addebiti</option>
													<option value="1">Accrediti</option>
												</select>
											</div>
											<div class="col-6 col-md-1">
												<button class="btn btn-flat-secondary btn-sm text-nowrap w-100" type="button" @click="resetStatsFilters">
													<i class="ph-x me-1"></i>Resetta
												</button>
											</div>
										</div>
									</form>
								</div>

						</div>
					</div>

					<div class="card-body pt-0">

							<!-- KPI -->
							<div class="row mb-4 g-3">
								<div class="col-6 col-md-3">
									<div class="card border-0 bg-secondary bg-opacity-10 text-center p-3">
										<div class="fs-sm text-muted mb-1">Totale importi</div>
										<div class="fw-bold fs-5 text-secondary">€ {{ filters.formattaImporto(kpiStats.totale) }}</div>
									</div>
								</div>
								<div class="col-6 col-md-3">
									<div class="card border-0 bg-primary bg-opacity-10 text-center p-3">
										<div class="fs-sm text-muted mb-1">Note spese</div>
										<div class="fw-bold fs-5 text-primary">{{ kpiStats.count }}</div>
									</div>
								</div>
								<div class="col-6 col-md-3">
									<div class="card border-0 bg-info bg-opacity-10 text-center p-3">
										<div class="fs-sm text-muted mb-1">Importo medio</div>
										<div class="fw-bold fs-5 text-info">€ {{ filters.formattaImporto(kpiStats.media) }}</div>
									</div>
								</div>
								<div class="col-6 col-md-3">
									<div class="card border-0 bg-success bg-opacity-10 text-center p-3">
										<div class="fs-sm text-muted mb-1">Utenti</div>
										<div class="fw-bold fs-5 text-success">{{ kpiStats.utenti }}</div>
									</div>
								</div>
							</div>

							<!-- Grafici -->
							<div class="row g-3">
								<div class="col-12 col-md-6">
									<div class="card border">
										<div class="card-header bg-secondary text-white py-2 px-3 fs-sm fw-semibold">Spese per utente</div>
										<div class="card-body p-2">
											<div id="chart-ns-utente" class="chart-ns"></div>
										</div>
									</div>
								</div>
								<div class="col-12 col-md-6">
									<div class="card border">
										<div class="card-header bg-secondary text-white py-2 px-3 fs-sm fw-semibold">Trend mensile importi (€)</div>
										<div class="card-body p-2">
											<div id="chart-ns-trend" class="chart-ns"></div>
										</div>
									</div>
								</div>
								<div class="col-12 col-md-6">
									<div class="card border">
										<div class="card-header bg-secondary text-white py-2 px-3 fs-sm fw-semibold">Spese per progetto</div>
										<div class="card-body p-2">
											<div id="chart-ns-progetto" class="chart-ns"></div>
										</div>
									</div>
								</div>
								<div class="col-12 col-md-6">
									<div class="card border">
										<div class="card-header bg-secondary text-white py-2 px-3 fs-sm fw-semibold">Note spese per mese</div>
										<div class="card-body p-2">
											<div id="chart-ns-mensile" class="chart-ns"></div>
										</div>
									</div>
								</div>
							</div>

					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- Modals -->
	<ImportSpeseExcel v-if="showModalNuovaElaborazione" @close="showModalNuovaElaborazione = false"
		@imported="onElaborazioneImportata" />
	<ModalUploadPdfElaborazione v-if="showModalUploadPdf" :is-admin-view="isAdminView"
		@close="showModalUploadPdf = false" @saved="onPdfCaricato" />
	<ModalUploadPdfNotaSpesa v-if="showModalUploadFattura" :nota-spesa="notaSpesaInEdit"
		@close="showModalUploadFattura = false" @saved="onFatturaCaricata" />
	<ModalAssociaNotaSpesa v-if="showModalAssocia" :nota-spesa="notaSpesaInEdit" :ids-bulk="associaBulkIds" @close="closeModalAssocia"
		@saved="getNoteSpese()" />
	<PopUpEsportazione id="popUpEsportazioneNoteSpese" @esporta="esportaDati" />
</template>

<script>
import NotaSpesaNode from '@/components/NotaSpesaNode.vue';
import ModalAssociaNotaSpesa from '@/components/ModalAssociaNotaSpesa.vue';
import ImportSpeseExcel from '@/components/ImportSpeseExcel.vue';
import ModalUploadPdfElaborazione from '@/components/ModalUploadPdfElaborazione.vue';
import ModalUploadPdfNotaSpesa from '@/components/ModalUploadPdfNotaSpesa.vue';
import Pagine from '@/components/utils/Pagine.vue';
import { VueDatePicker as Datepicker } from '@vuepic/vue-datepicker';
import Select2Locale from '@/components/utils/Select2Locale.vue';
import PopUpEsportazione from '@/components/common/PopUpEsportazione.vue';
import ISort from '@/components/utils/ISort.vue';
import { useSubmenuTouch } from '@/composables/useSubmenuTouch.js';
import { ref } from 'vue';

export default {
	name: 'NoteSpese',
	components: {
		NotaSpesaNode,
		ModalAssociaNotaSpesa,
		ImportSpeseExcel,
		ModalUploadPdfElaborazione,
		ModalUploadPdfNotaSpesa,
		Pagine,
		Datepicker,
		PopUpEsportazione,
		Select2Locale,
		ISort,
	},
	setup() {
		const azioniMultipleMenu = ref(null);
		useSubmenuTouch(azioniMultipleMenu);
		return { azioniMultipleMenu };
	},
	data() {
		return {
			arrayNoteSpese: [],
			arrayCategorieSpese: [],
			arrayElaborazioni: [],
			optionsUtentiFiltro: [],
			optionsProgettiFiltro: [],
			showModalAssocia: false,
			showModalNuovaElaborazione: false,
			showModalUploadPdf: false,
			showModalUploadFattura: false,
			expandedElab: {},
			notaSpesaInEdit: null,
			associaBulkIds: null,
			loading: false,
			esportazioneTipo: '',
			dataFrom: null,
			dataTo: null,
			statsDataFrom: null,
			statsDataTo: null,
			elabDataFrom: null,
			elabDataTo: null,
			filters: global.filters,
			utils: global.utils,
			search: {
				DESCRIZIONE: { TYPE: 'TEXT', VALUE: '' },
				FK_ID_UTENTE: { TYPE: 'CUSTOM', VALUE: '' },
				FK_ID_PROGETTO: { TYPE: 'CUSTOM', VALUE: '' },
				FLG_FATTURA: { TYPE: 'COMBO', VALUE: '' },
				TIPO_MOVIMENTO: { TYPE: 'COMBO', VALUE: '' },
				ASSOCIATO: { TYPE: 'CUSTOM', VALUE: '' },
				FK_ID_CATEGORIA: { TYPE: 'COMBO', VALUE: '' },
				DATA: { TYPE: 'CUSTOM', VALUE_FROM: '', VALUE_TO: '' },
				FLG_ELIMINATO: { TYPE: 'COMBO', VALUE: '0' },
				PAGINATION: {
					PAGE_NUMBER: 1,
					PAGE_SIZE: 25,
					LENGTH: 0
				}
			},
			ordinamento: '',
			searchStats: {
				DATA_FROM: '',
				DATA_TO: '',
				NOME_UTENTE: '',
				FK_ID_PROGETTO: '',
				TIPO_MOVIMENTO: '',
			},
			searchElab: {
				NOME_UTENTE: '',
				DATA_FROM: '',
				DATA_TO: '',
				QUADRATURA: '',
			}
		};
	},
	computed: {
		isAdminView() {
			// HACK temporaneo (permessi non ancora implementati): questi utenti
			// (ID 5, 6, 7) hanno la vista admin sulle note spese. Rimuovere quando
			// NOTE_SPESE_ADMIN sarà assegnabile via permessi.
			return this.$root.isGod
				|| [5, 6, 7].includes(this.$root.utente.ID_UTENTE)
				|| utils.permissions.hasFunzionalita('NOTE_SPESE_ADMIN');
		},
		paginatedList() {
			let filtered = this.arrayNoteSpese;

			// Filtro data (manuale — DATA è CUSTOM, ignorato da inGrid/utils.filter)
			const fromStr = this.search.DATA.VALUE_FROM
				? this.filters.formatDateReverse(this.search.DATA.VALUE_FROM) : null;
			const toStr   = this.search.DATA.VALUE_TO
				? this.filters.formatDateReverse(this.search.DATA.VALUE_TO)   : null;
			if (fromStr || toStr) {
				filtered = filtered.filter(n => {
					const d = n.DATA ? n.DATA.substring(0, 10) : null;
					if (!d) return false;
					if (fromStr && d < fromStr) return false;
					if (toStr   && d > toStr)   return false;
					return true;
				});
			}

			// Filtri COMBO manuali
			if (this.search.ASSOCIATO.VALUE == '1')
				filtered = filtered.filter(n => n.FK_ID_PROGETTO && n.FK_ID_PROGETTO != 0);
			else if (this.search.ASSOCIATO.VALUE == '0')
				filtered = filtered.filter(n => !n.FK_ID_PROGETTO || n.FK_ID_PROGETTO == 0);

			if (this.search.FLG_FATTURA.VALUE == '1')
				filtered = filtered.filter(n => n.FLG_FATTURA == 1);
			else if (this.search.FLG_FATTURA.VALUE == '0')
				filtered = filtered.filter(n => n.FLG_FATTURA == 0);

			if (this.search.TIPO_MOVIMENTO.VALUE == '1')
				filtered = filtered.filter(n => n.TIPO_MOVIMENTO == 1);
			else if (this.search.TIPO_MOVIMENTO.VALUE == '0')
				filtered = filtered.filter(n => n.TIPO_MOVIMENTO == 0);

			if (this.search.FK_ID_CATEGORIA.VALUE !== '')
				filtered = filtered.filter(n => n.FK_ID_CATEGORIA == this.search.FK_ID_CATEGORIA.VALUE);

			if (this.search.FK_ID_UTENTE.VALUE !== '')
				filtered = filtered.filter(n => n.FK_ID_UTENTE == this.search.FK_ID_UTENTE.VALUE);

			if (this.search.FK_ID_PROGETTO.VALUE !== '')
				filtered = filtered.filter(n => n.FK_ID_PROGETTO == this.search.FK_ID_PROGETTO.VALUE);

			// utils.inGrid gestisce TEXT (DESCRIZIONE) e paginazione
			return utils.inGrid(filtered, this.search, this.ordinamento);
		},

		// ── Statistiche ────────────────────────────────────────────────────────
		filteredStatsNotes() {
			let notes = this.arrayNoteSpese;
			if (this.searchStats.NOME_UTENTE)
				notes = notes.filter(n => n.NOME_UTENTE == this.searchStats.NOME_UTENTE);
			if (this.searchStats.DATA_FROM)
				notes = notes.filter(n => n.DATA && n.DATA.substring(0, 10) >= this.searchStats.DATA_FROM);
			if (this.searchStats.DATA_TO)
				notes = notes.filter(n => n.DATA && n.DATA.substring(0, 10) <= this.searchStats.DATA_TO);
			if (this.searchStats.FK_ID_PROGETTO)
				notes = notes.filter(n => n.FK_ID_PROGETTO == this.searchStats.FK_ID_PROGETTO);
			if (this.searchStats.TIPO_MOVIMENTO !== '')
				notes = notes.filter(n => n.TIPO_MOVIMENTO == this.searchStats.TIPO_MOVIMENTO);
			return notes;
		},
		utentiStats() {
			return [...new Set(this.arrayNoteSpese.map(n => n.NOME_UTENTE))].filter(Boolean).sort();
		},
		progettiStats() {
			const seen = {};
			let notes = this.arrayNoteSpese;
			if (this.searchStats.NOME_UTENTE)
				notes = notes.filter(n => n.NOME_UTENTE == this.searchStats.NOME_UTENTE);
			if (this.searchStats.DATA_FROM)
				notes = notes.filter(n => n.DATA && n.DATA.substring(0, 10) >= this.searchStats.DATA_FROM);
			if (this.searchStats.DATA_TO)
				notes = notes.filter(n => n.DATA && n.DATA.substring(0, 10) <= this.searchStats.DATA_TO);
			notes.forEach(n => {
				if (n.FK_ID_PROGETTO && n.FK_ID_PROGETTO != 0 && !seen[n.FK_ID_PROGETTO])
					seen[n.FK_ID_PROGETTO] = n.TITOLO_PROGETTO || 'Sconosciuto';
			});
			return Object.entries(seen)
				.map(([id, title]) => ({ id, title }))
				.sort((a, b) => a.title.localeCompare(b.title));
		},
		kpiStats() {
			const notes = this.filteredStatsNotes;
			const totale = utils.array.sumByFieldSigned(notes, 'IMPORTO', 'TIPO_MOVIMENTO');
			const utenti = new Set(notes.map(n => n.NOME_UTENTE)).size;
			return {
				totale,
				count: notes.length,
				media: notes.length > 0 ? totale / notes.length : 0,
				utenti
			};
		},
		chartDataUtente() {
			const byUser = {};
			this.filteredStatsNotes.forEach(n => {
				if (!byUser[n.NOME_UTENTE]) byUser[n.NOME_UTENTE] = 0;
				byUser[n.NOME_UTENTE] += n.TIPO_MOVIMENTO == 0
					? -parseFloat(n.IMPORTO || 0)
					:  parseFloat(n.IMPORTO || 0);
			});
			return Object.entries(byUser)
				.map(([name, value]) => ({ name, value: Math.round(value * 100) / 100 }))
				.sort((a, b) => a.value - b.value);
		},
		chartDataTrend() {
			const byMese = {};
			this.filteredStatsNotes.forEach(n => {
				const m = (n.DATA || '').substring(0, 7);
				if (m) byMese[m] = (byMese[m] || 0) + (n.TIPO_MOVIMENTO == 0 ? -parseFloat(n.IMPORTO || 0) : parseFloat(n.IMPORTO || 0));
			});
			const mesi = Object.keys(byMese).sort();
			return { mesi, importi: mesi.map(m => Math.round(byMese[m] * 100) / 100) };
		},
		chartDataProgetto() {
			const byProg = {};
			this.filteredStatsNotes.forEach(n => {
				const key = (n.FK_ID_PROGETTO && n.FK_ID_PROGETTO != 0) ? (n.TITOLO_PROGETTO || 'Sconosciuto') : 'Non associata';
				byProg[key] = (byProg[key] || 0) + parseFloat(n.IMPORTO || 0);
			});
			return Object.entries(byProg)
				.map(([name, value]) => ({ name, value: Math.round(value * 100) / 100 }))
				.filter(d => d.value > 0)
				.sort((a, b) => b.value - a.value)
				.slice(0, 6);
		},
		chartDataMensile() {
			const byMese = {};
			this.filteredStatsNotes.forEach(n => {
				const m = (n.DATA || '').substring(0, 7);
				if (m) byMese[m] = (byMese[m] || 0) + 1;
			});
			const mesi = Object.keys(byMese).sort();
			return { mesi, conteggi: mesi.map(m => byMese[m]) };
		},

		// ── Elaborazioni ───────────────────────────────────────────────────────
		filteredElaborazioni() {
			let elabs = this.arrayElaborazioni;
			if (this.searchElab.NOME_UTENTE)
				elabs = elabs.filter(e => e.NOME_UTENTE == this.searchElab.NOME_UTENTE);
			if (this.searchElab.DATA_FROM)
				elabs = elabs.filter(e => e.DATA && e.DATA.substring(0, 10) >= this.searchElab.DATA_FROM);
			if (this.searchElab.DATA_TO)
				elabs = elabs.filter(e => e.DATA && e.DATA.substring(0, 10) <= this.searchElab.DATA_TO);
			if (this.searchElab.QUADRATURA != '')
				elabs = elabs.filter(e => (this.quadraturaOk(e) ? '1' : '0') == this.searchElab.QUADRATURA);
			return elabs;
		},
		utentiElab() {
			return [...new Set(this.arrayElaborazioni.map(e => e.NOME_UTENTE))].filter(Boolean).sort();
		},
	},
	watch: {
		searchStats: {
			deep: true,
			handler() { this.$nextTick(() => this.initCharts()); }
		},
		progettiStats(lista) {
			const ids = lista.map(p => p.id);
			if (this.searchStats.FK_ID_PROGETTO && !ids.includes(this.searchStats.FK_ID_PROGETTO))
				this.searchStats.FK_ID_PROGETTO = '';
		},
	},
	methods: {
		getNoteSpese() {
			this.loading = true;
			const payload = {
				FK_ID_UTENTE: this.$root.utente.ID_UTENTE,
				FK_ID_LIVELLO: this.isAdminView ? 1 : this.$root.utente.FK_ID_LIVELLO
			};

			utils.ajax('theb/notespese/tutte', payload, (response) => {
				if (response.esito == 0) {
					this.arrayNoteSpese = response.data || [];
					this.search.PAGINATION.PAGE_NUMBER = 1;
				} else {
					utils.alert.warning('Errore nel caricamento');
				}
				this.loading = false;
			});
		},
		apriAzioni({ azione, notaSpesa }) {
			switch (azione) {
				case 'associa':
					this.notaSpesaInEdit = notaSpesa;
					this.showModalAssocia = true;
					break;
				case 'upload-fattura':
					this.notaSpesaInEdit = notaSpesa;
					this.showModalUploadFattura = true;
					break;
				case 'elimina-definitivamente':
					this.eliminaDefinitivamenteNota(notaSpesa.ID_NOTA_SPESA);
					break;
				case 'ripristina':
					this.ripristinaNota(notaSpesa.ID_NOTA_SPESA);
					break;
				case 'segna-fattura':
					utils.ajax('theb/notaspesa/imposta-fattura-bulk', { IDS: [notaSpesa.ID_NOTA_SPESA] }, (r) => {
						if (r.esito == 0) { this.getNoteSpese(); utils.alert.success('Nota spesa segnata come Fattura.'); }
					});
					break;
				case 'segna-scontrino':
					utils.ajax('theb/notaspesa/imposta-scontrino-bulk', { IDS: [notaSpesa.ID_NOTA_SPESA] }, (r) => {
						if (r.esito == 0) { this.getNoteSpese(); utils.alert.success('Nota spesa segnata come Scontrino.'); }
					});
					break;
				case 'refresh':
					this.getNoteSpese();
					break;
			}
		},
		eliminaDefinitivamenteNota(id) {
			utils.alert.confirm('Eliminare DEFINITIVAMENTE questa nota spesa? Azione irreversibile.', () => {
				utils.ajax('theb/notaspesa/harddelete', { ID_NOTA_SPESA: id }, (response) => {
					if (response.esito == 0) {
						this.getNoteSpese();
						utils.alert.success('Nota spesa eliminata definitivamente.');
					}
				});
			}, this.$root);
		},
		ripristinaNota(id) {
			utils.ajax('theb/notaspesa/ripristina', { ID_NOTA_SPESA: id }, (response) => {
				if (response.esito == 0) {
					this.getNoteSpese();
					utils.alert.success('Nota spesa ripristinata con successo.');
					utils.notifiche.invia(this, 'NOTA_SPESA_MODIFICA', 'ha ripristinato una nota spesa');
				}
			});
		},
		apriEsportazione: function(tipo) {
			this.esportazioneTipo = tipo;
			this.filters.openPopUp('popUpEsportazioneNoteSpese');
		},
		esportaDati: function(formato) {
			utils.esportaTabella({
				tipo:          this.esportazioneTipo,
				formato:       formato,
				arrayCompleto: this.arrayNoteSpese,
				arrayPagina:   this.paginatedList.arr,
				idField:       'ID_NOTA_SPESA',
				modulo:        'noteSpese',
				nomeFile:      'note_spese'
			});
		},
		attivaSelezionati() {
			var selezionate = utils.array.select(this.arrayNoteSpese, 'SELEZIONATO', 1);
			if (selezionate.length == 0) { utils.alert.warning('Nessuna nota spesa selezionata.'); return; }
			utils.alert.confirm('Attivare ' + selezionate.length + ' nota/e spesa/e?', () => {
				utils.ajax('theb/notaspesa/attiva-bulk', { IDS: selezionate.map(n => n.ID_NOTA_SPESA) }, (r) => {
					if (r.esito == 0) { this.getNoteSpese(); utils.alert.success('Note spese attivate con successo.'); }
				});
			}, this.$root);
		},
		disattivaSelezionati() {
			var selezionate = utils.array.select(this.arrayNoteSpese, 'SELEZIONATO', 1);
			if (selezionate.length == 0) { utils.alert.warning('Nessuna nota spesa selezionata.'); return; }
			utils.alert.confirm('Disattivare ' + selezionate.length + ' nota/e spesa/e?', () => {
				utils.ajax('theb/notaspesa/disattiva-bulk', { IDS: selezionate.map(n => n.ID_NOTA_SPESA) }, (r) => {
					if (r.esito == 0) { this.getNoteSpese(); utils.alert.success('Note spese disattivate con successo.'); }
				});
			}, this.$root);
		},
		segnaScontriniSelezionati() {
			var selezionate = utils.array.select(this.arrayNoteSpese, 'SELEZIONATO', 1);
			if (selezionate.length == 0) { utils.alert.warning('Nessuna nota spesa selezionata.'); return; }
			utils.alert.confirm('Segnare come Scontrino ' + selezionate.length + ' nota/e spesa/e?', () => {
				utils.ajax('theb/notaspesa/imposta-scontrino-bulk', { IDS: selezionate.map(n => n.ID_NOTA_SPESA) }, (r) => {
					if (r.esito == 0) { this.getNoteSpese(); utils.alert.success('Note spese impostate come Scontrino con successo.'); }
				});
			}, this.$root);
		},
		segnaFattureSelezionati() {
			var selezionate = utils.array.select(this.arrayNoteSpese, 'SELEZIONATO', 1);
			if (selezionate.length == 0) { utils.alert.warning('Nessuna nota spesa selezionata.'); return; }
			utils.alert.confirm('Segnare come Fattura ' + selezionate.length + ' nota/e spesa/e?', () => {
				utils.ajax('theb/notaspesa/imposta-fattura-bulk', { IDS: selezionate.map(n => n.ID_NOTA_SPESA) }, (r) => {
					if (r.esito == 0) { this.getNoteSpese(); utils.alert.success('Note spese impostate come Fattura con successo.'); }
				});
			}, this.$root);
		},
		associaProgettoSelezionati() {
			var selezionate = utils.array.select(this.arrayNoteSpese, 'SELEZIONATO', 1);
			if (selezionate.length == 0) { utils.alert.warning('Nessuna nota spesa selezionata.'); return; }
			this.associaBulkIds = selezionate.map(n => n.ID_NOTA_SPESA);
			this.notaSpesaInEdit = null;
			this.showModalAssocia = true;
		},
		closeModalAssocia() {
			this.showModalAssocia = false;
			this.notaSpesaInEdit = null;
			this.associaBulkIds = null;
		},
		onTabStatistiche() {
			setTimeout(() => {
				this.initCharts();
			}, 200);
		},
		getElaborazioni() {
			utils.ajax('theb/elaborazioni/tutte', {}, (res) => {
				if (res.esito == 0) {
					this.arrayElaborazioni = res.data || [];
				}
			});
		},
		onTabElaborazioni() {
			this.getElaborazioni();
		},
		onElaborazioneImportata() {
			this.showModalNuovaElaborazione = false;
			this.getElaborazioni();
			this.getNoteSpese();
		},
		apriUploadPdf() {
			this.showModalUploadPdf = true;
		},
		onPdfCaricato() {
			this.showModalUploadPdf = false;
			this.getNoteSpese();
			this.getElaborazioni();
		},
		onFatturaCaricata() {
			this.showModalUploadFattura = false;
			this.getNoteSpese();
		},
		quadraturaOk(elab) {
			return (parseInt(elab.TOT_SCONTRINI) + parseInt(elab.TOT_FATTURE)) == parseInt(elab.TOT_MOVIMENTI);
		},
		isElabExpanded(key) {
			return this.expandedElab[key] == true;
		},
		toggleElab(key) {
			this.expandedElab[key] = !this.isElabExpanded(key);
		},
		initCharts() {
			const isMobile = this.$root.isMobile;
			const elUtente = document.getElementById('chart-ns-utente');
			if (elUtente) {
				const c = echarts.getInstanceByDom(elUtente) || echarts.init(elUtente);
				const data = this.chartDataUtente;
				c.setOption({
					tooltip: { trigger: 'axis', formatter: p => p[0].name + ': € ' + utils.formatNumber(p[0].value) },
					grid: { left: '2%', right: '5%', top: '5%', bottom: '8%', containLabel: true },
					xAxis: {
						type: 'value',
						axisLabel: { formatter: v => '€ ' + utils.formatNumberInt(v), hideOverlap: true, fontSize: isMobile ? 10 : 12 }
					},
					yAxis: {
						type: 'category',
						data: data.map(d => d.name),
						axisLabel: {
							fontSize: isMobile ? 10 : 12,
							formatter: v => isMobile ? this.filters.accorciaTesto(v, 14) : v
						}
					},
					series: [{ type: 'bar', data: data.map(d => d.value), itemStyle: { color: '#6c757d' } }]
				});
			}
			const elTrend = document.getElementById('chart-ns-trend');
			if (elTrend) {
				const c = echarts.getInstanceByDom(elTrend) || echarts.init(elTrend);
				const data = this.chartDataTrend;
				c.setOption({
					tooltip: { trigger: 'axis', formatter: p => p[0].axisValue + ': € ' + utils.formatNumber(p[0].value) },
					grid: { left: '2%', right: '5%', top: '8%', bottom: '15%', containLabel: true },
					xAxis: {
						type: 'category',
						data: data.mesi,
						axisLabel: { rotate: 30, hideOverlap: true, fontSize: isMobile ? 10 : 12 }
					},
					yAxis: {
						type: 'value',
						axisLabel: { formatter: v => '€ ' + utils.formatNumberInt(v), hideOverlap: true, fontSize: isMobile ? 10 : 12 }
					},
					series: [{ type: 'line', data: data.importi, smooth: true, areaStyle: { opacity: 0.2 }, itemStyle: { color: '#0d6efd' } }]
				});
			}
			const elProg = document.getElementById('chart-ns-progetto');
			if (elProg) {
				const c = echarts.getInstanceByDom(elProg) || echarts.init(elProg);
				const legend = isMobile
					? { orient: 'horizontal', bottom: 0, type: 'scroll', textStyle: { fontSize: 11 } }
					: { orient: 'vertical', right: '5%', top: 'center', type: 'scroll', textStyle: { fontSize: 11 } };
				const center = isMobile ? ['50%', '38%'] : ['35%', '50%'];
				c.setOption({
					tooltip: { trigger: 'item', formatter: p => p.name + ': € ' + utils.formatNumber(p.value) + ' (' + p.percent + '%)' },
					legend,
					series: [{
						type: 'pie', radius: ['40%', '70%'], center,
						data: this.chartDataProgetto,
						label: { show: false }
					}]
				}, true);
			}
			const elMens = document.getElementById('chart-ns-mensile');
			if (elMens) {
				const c = echarts.getInstanceByDom(elMens) || echarts.init(elMens);
				const data = this.chartDataMensile;
				c.setOption({
					tooltip: { trigger: 'axis' },
					grid: { left: '2%', right: '5%', top: '8%', bottom: '15%', containLabel: true },
					xAxis: {
						type: 'category',
						data: data.mesi,
						axisLabel: { rotate: 30, hideOverlap: true, fontSize: isMobile ? 10 : 12 }
					},
					yAxis: { type: 'value', minInterval: 1, axisLabel: { hideOverlap: true, fontSize: isMobile ? 10 : 12 } },
					series: [{ type: 'bar', data: data.conteggi, itemStyle: { color: '#20c997' } }]
				});
			}
		},
		resetStatsFilters() {
			this.searchStats.DATA_FROM = '';
			this.searchStats.DATA_TO = '';
			this.searchStats.NOME_UTENTE = '';
			this.searchStats.FK_ID_PROGETTO = '';
			this.searchStats.TIPO_MOVIMENTO = '';
			this.statsDataFrom = null;
			this.statsDataTo = null;
		},
		handleStatsDataFromChange() {
			this.searchStats.DATA_FROM = this.statsDataFrom || '';
		},
		handleStatsDataToChange() {
			this.searchStats.DATA_TO = this.statsDataTo || '';
		},
		resetElabFilters() {
			this.searchElab.NOME_UTENTE = '';
			this.searchElab.DATA_FROM = '';
			this.searchElab.DATA_TO = '';
			this.searchElab.QUADRATURA = '';
			this.elabDataFrom = null;
			this.elabDataTo = null;
		},
		handleElabDataFromChange() {
			this.searchElab.DATA_FROM = this.elabDataFrom || '';
		},
		handleElabDataToChange() {
			this.searchElab.DATA_TO = this.elabDataTo || '';
		},
		resetFilters() {
			this.search.DESCRIZIONE.VALUE = '';
			this.search.FK_ID_UTENTE.VALUE = '';
			this.search.FK_ID_PROGETTO.VALUE = '';
			this.search.FLG_FATTURA.VALUE = '';
			this.search.TIPO_MOVIMENTO.VALUE = '';
			this.search.ASSOCIATO.VALUE = '';
			this.search.FK_ID_CATEGORIA.VALUE = '';
			this.search.DATA.VALUE_FROM = '';
			this.search.DATA.VALUE_TO = '';
			this.search.PAGINATION.PAGE_NUMBER = 1;
			this.dataFrom = null;
			this.dataTo = null;
		},
		handleDataFromChange() {
			this.search.DATA.VALUE_FROM = '';
			if (this.dataFrom) {
				this.search.DATA.VALUE_FROM = this.filters.formatDate(this.dataFrom);
			}
		},
		handleDataToChange() {
			this.search.DATA.VALUE_TO = '';
			if (this.dataTo) {
				this.search.DATA.VALUE_TO = this.filters.formatDate(this.dataTo);
			}
		}
	},
	created() {
		this.getNoteSpese();
		utils.ajax('shared/tipologiche', { FK_ID_MODULO: 62 }, (res) => {
			if (res.esito == 0 && res.data.length > 0) {
				utils.ajax('shared/tipologica', { ID_TIPOLOGICA: res.data[0].ID_TIPOLOGICA }, (res2) => {
					if (res2.esito == 0) this.arrayCategorieSpese = res2.data.opzioni || [];
				});
			}
		});
		if (this.isAdminView) {
			utils.ajax('theb/s2/notespese-utenti', { q: '' }, (res) => {
				if (res.esito == 0) this.optionsUtentiFiltro = res.data;
			});
		}
		utils.ajax('theb/progetti', {}, (res) => {
			if (res.esito == 0) this.optionsProgettiFiltro = res.data.map((p) => ({ id: p.ID_PROGETTO, text: p.TITOLO }));
		});
	}
};
</script>

<style scoped>
.tableFixHead {
	overflow-y: auto;
	min-height: calc(100vh - 392px);
}

.tableFixHead thead th {
	position: sticky;
	top: 0;
	z-index: 10;
}

.chart-ns {
	height: 300px;
}

.min-w-0 {
	min-width: 0;
}

.elab-mobile-row {
	cursor: pointer;
}

.elab-mobile-details {
	background-color: rgba(0, 0, 0, 0.03);
	border-top: 1px solid #ccc;
	font-size: 0.8rem;
}

@media (max-width: 991.98px) {
	#profile_nav .dropdown-menu {
		position: absolute !important;
	}
}

@media (max-width: 767.98px) {
	.chart-ns {
		height: 260px;
	}
}

</style>